export function isValidDate(value: unknown): boolean {
  const date = new Date(value as string);
  return !isNaN(date.getTime());
}
